import React from 'react';
import { motion } from 'framer-motion';
import { 
  EnvelopeIcon, 
  PhoneIcon, 
  MapPinIcon,
  HeartIcon
} from '@heroicons/react/24/outline';

const Footer = () => {
  const footerLinks = {
    company: [
      { name: 'About Us', href: '#about' },
      { name: 'Our Story', href: '#about' },
      { name: 'Manufacturing', href: '#services' },
      { name: 'Certifications', href: '#certificate' }
    ],
    services: [
      { name: 'Custom Design', href: '#services' },
      { name: 'Sample Development', href: '#services' },
      { name: 'Bulk Manufacturing', href: '#services' },
      { name: 'Quality Assurance', href: '#services' }
    ],
    products: [
      { name: 'Men\'s Apparel', href: '#portfolio' },
      { name: 'Women\'s Fashion', href: '#portfolio' },
      { name: 'Kids\' Clothing', href: '#portfolio' },
      { name: 'Women\'s Dresses', href: '#portfolio' }
    ],
    support: [
      { name: 'Contact Us', href: '#contact' },
      { name: 'Get Quote', href: '#contact' },
      { name: 'Email', href: '#contact' },
      { name: 'Support Center', href: '#contact' },
    ]
  };

  const socialLinks = [
    { name: 'LinkedIn', href: '#', icon: 'linkedin' },
    { name: 'WhatsApp', href: 'https://wa.me/919820440298?text=Hello%20I%20want%20to%20start%20a%20project', icon: 'whatsapp' },
    { name: 'Instagram', href: '#', icon: 'instagram' },
    { name: 'Facebook', href: '#', icon: 'facebook' },
    { name: 'Twitter', href: '#', icon: 'twitter' }
  ];

  const SocialIcon = ({ icon }) => {
    const iconPaths = {
      linkedin: "M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z",
      instagram: "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z",
      facebook: "M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z",
      twitter: "M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z",
      whatsapp:"M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.372-.025-.521-.075-.149-.669-1.61-.916-2.202-.242-.583-.487-.502-.669-.51-.173-.008-.372-.009-.571-.009-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.877 1.213 3.076.149.198 2.098 3.205 5.072 4.373.71.305 1.263.487 1.695.623.713.227 1.362.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.002C4.584 21.782.218 17.415.215 12.041.213 6.658 4.566 2.291 9.949 2.291c5.383 0 9.749 4.367 9.751 9.75.002 5.374-4.364 9.741-9.741 9.744z"
    };

    return (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d={iconPaths[icon]} />
      </svg>
    );
  };

  return (
    <footer className="bg-honeycomb-grey-900 text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }} />
      </div>

      {/* Main Footer Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-8">
        {/* Top Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-12">
          {/* Company Info */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="space-y-6"
          >
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 bg-gradient-to-br from-honeycomb-blue-600 to-honeycomb-blue-700 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-2xl">H</span>
              </div>
              <div>
                <h3 className="text-2xl font-display font-bold text-white">
                  Honeycomb Exports
                </h3>
                <p className="text-honeycomb-blue-200 text-sm">
                  Global Manufacturing Excellence
                </p>
              </div>
            </div>
            
            <p className="text-honeycomb-grey-300 text-lg leading-relaxed max-w-md">
              Crafting premium garments for global brands since 2001. 
              Your trusted partner for quality manufacturing and timely delivery.
            </p>

          </motion.div>

          {/* Newsletter Signup 
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="bg-honeycomb-grey-800 p-8 rounded-2xl border border-honeycomb-grey-700"
          >
            <h4 className="text-2xl font-semibold text-white mb-4">
              Stay Updated
            </h4>
            <p className="text-honeycomb-grey-300 mb-6">
              Get the latest updates on our services, industry trends, and exclusive offers.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <input
                type="email"
                placeholder="Enter your email"
                className="flex-1 px-4 py-3 bg-honeycomb-grey-700 border border-honeycomb-grey-600 rounded-lg text-white placeholder-honeycomb-grey-400 focus:outline-none focus:ring-2 focus:ring-honeycomb-blue-500 focus:border-honeycomb-blue-500"
              />
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="bg-honeycomb-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-honeycomb-blue-700 transition-colors btn-primary"
              >
                Subscribe
              </motion.button>
            </div>
          </motion.div>*/}
            {/* Contact Quick Info */}
            <div className="space-y-3">
              <div className="flex items-center space-x-3 text-honeycomb-grey-300">
                <EnvelopeIcon className="h-5 w-5 text-honeycomb-blue-400" />
                <span>info@honeycombexports.com</span>
              </div>
              <div className="flex items-center space-x-3 text-honeycomb-grey-300">
                <PhoneIcon className="h-5 w-5 text-honeycomb-blue-400" />
                <span>022 6692 9892</span>
              </div>
              <div className="flex items-center space-x-3 text-honeycomb-grey-300">
                <MapPinIcon className="h-5 w-5 text-honeycomb-blue-400" />
                <span>20 B, SteelMade Industrial Estate, Andheri East</span>
              </div>
            </div>
        </div>

        {/* Links Section */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          {Object.entries(footerLinks).map(([category, links], index) => (
            <motion.div
              key={category}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.1 * index }}
            >
              <h4 className="text-lg font-semibold text-white mb-4 capitalize">
                {category}
              </h4>
              <ul className="space-y-2">
                {links.map((link) => (
                  <li key={link.name}>
                    <motion.a
                      href={link.href}
                      whileHover={{ x: 5 }}
                      className="text-honeycomb-grey-300 hover:text-honeycomb-blue-400 transition-colors"
                      onClick={(e) => {
                        if (link.href.startsWith('#')) {
                          e.preventDefault();
                          document.querySelector(link.href)?.scrollIntoView({
                            behavior: 'smooth'
                          });
                        }
                      }}
                    >
                      {link.name}
                    </motion.a>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>

        {/* Bottom Section */}
        <div className="border-t border-honeycomb-grey-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            {/* Copyright */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="flex items-center space-x-2 text-honeycomb-grey-400"
            >
              <span>&copy; 2024 Honeycomb Exports. All rights reserved.</span>
              <span>•</span>
              <span>Made with</span>
              <HeartIcon className="h-4 w-4 text-red-500" />
              <span>for global fashion</span>
            </motion.div>

            {/* Social Links */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="flex items-center space-x-4"
            >
              {socialLinks.map((social) => (
                <motion.a
                  key={social.name}
                  href={social.href}
                  whileHover={{ scale: 1.1, y: -2 }}
                  whileTap={{ scale: 0.9 }}
                  className="p-2 bg-honeycomb-grey-800 rounded-lg text-honeycomb-grey-300 hover:text-honeycomb-blue-400 hover:bg-honeycomb-grey-700 transition-colors"
                  title={social.name}
                >
                  <SocialIcon icon={social.icon} />
                </motion.a>
              ))}
            </motion.div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
